import type { ComponentDocMap } from './types'

/**
 * Prop documentation for the `horizontal_bars` component.
 * Keep in sync with HorizontalBarsProps in src/ui/uiConfig/components/HorizontalBars/HorizontalBars.types.ts
 */
export const horizontalBarsPropDocs: ComponentDocMap = {
  items: {
    description: 'Bar segment definitions. Same shape as pie_chart items.',
    type: 'StackedChartItem[]',
    example: '[{ title: "__Steam", data_id: "steam", stack_group: 0, color: "$color-2" }]',
  },
  stack_groups: {
    description: 'Group definitions referenced by items[].stack_group.',
    type: 'StackGroup[]',
    example: '[{ id: 0, title: "__Current" }]',
  },
  'stack_groups[].title': {
    description: 'Group label shown in legend/labels.',
    type: 'string',
  },
  'stack_groups[].id': {
    description: 'Group identifier.',
    type: 'string | number',
  },
  title: {
    description: 'Title displayed above the chart.',
    type: 'string',
    example: '"__Fuel split"',
  },
  data_type: {
    description: 'Fallback data_type for item formatting.',
    type: 'string',
    example: '"energy"',
  },
}
